import { connectEventCapacityWaitlistTicketsPage } from '../containers/ticketSelection/connectEventCapacityWaitlistTicketsPage';

export default connectEventCapacityWaitlistTicketsPage();
